import { render, staticRenderFns } from "./ClientTicketsList.vue?vue&type=template&id=bb7e2464"
import script from "./ClientTicketsList.vue?vue&type=script&lang=js"
export * from "./ClientTicketsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports